<template>
  <div>
    <b-row>
      <b-col lg="6" class="px-1">
        <div
          v-for="add in addsPrepared.slice(0, 4)"
          :key="add"
          :class="getClass(add) + ' addon-' + add"
        >
          <img
            v-if="checked(add)"
            :src="checkIcon"
            alt="check"
            class="mb-1 checked-add"
          />
          <img v-else :src="xIcon" alt="" class="mb-1" />
          <label class="mb-0 addscontent">{{ label(add) }}</label>
        </div>
      </b-col>
      <b-col lg="6" class="pl-1 pr-0">
        <div
          v-for="add in addsPrepared.slice(-(addsPrepared.length - 4))"
          :key="add"
          :class="getClass(add) + ' addon-' + add"
        >
          <img v-if="checked(add)" :src="checkIcon" alt="check" class="mb-1" />
          <img v-else :src="xIcon" alt="" />
          <label class="mb-0 addscontent">{{ label(add) }}</label>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { adds, a_sam, a_skp_B, a_skp_F, a_skp_O } from '../config/adds';
import { modules } from '../config/modules';

export default {
  name: 'Adds',
  props: {
    checkedAdds: {},
    checkedModules: {},
    year: {},
    isAccountant: {},
    isLimitedVersion: {},
    checkIcon: {},
    xIcon: {},
    hasLimitedVersions: {},
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      client: 'auth/client',
    }),
    annualDeclaration() {
      let lastYear = (this.year.slice(this.year.length - 1) - 1).toString();
      return this.checkedAdds.includes(lastYear);
    },
    addsPrepared() {
      let adds;
      let that = this;

      if (this.program === 'sam') {
        adds = a_sam;
      } else {
        adds = this.isAccountant
          ? a_skp_B
          : this.isLimitedVersion
          ? a_skp_O
          : a_skp_F;
      }

      adds.forEach(function (add) {
        if (
          that.checkedAdds.includes(add) ||
          that.checkedModules.includes(add)
        ) {
          adds = adds.filter((item) => item !== add);
          adds.unshift(add);
        }
      });

      if (!this.isLimitedVersion) {
        if (this.annualDeclaration) {
          adds = adds.filter((item) => item !== 'decl');
          adds.unshift('decl');
        } else {
          adds = adds.filter((item) => item !== 'decl');
          adds.push('decl');
        }
      }

      if (this.isAccountant) {
        if (!this.checkedAdds.includes('X') || this.hasLimitedVersions) {
          adds = adds.filter((item) => item !== 'O');
        }
      }

      return adds;
    },
  },

  methods: {
    label(value) {
      if (value in adds) {
        return adds[value].label;
      } else if (value in modules) {
        return modules[value].label;
      } else if (value === 'decl') {
        return 'Deklaracje roczne';
      }
      return '';
    },
    checked(value) {
      return (
        this.checkedAdds.includes(value) ||
        this.checkedModules.includes(value) ||
        (value === 'decl' && this.annualDeclaration)
      );
    },
    getClass(add) {
      if (!this.checked(add)) {
        return 'text-secondary px-1 m-1 unchecked-add';
      } else {
        return 'border px-1 m-1 checked-add';
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .unchecked-add.addon-A {
    display: none;
  }
}
</style>
